<template>
  <div>
    <b-card>
      <div
        class="col-md-12col-sm-12 d-flex flex-column flex-md-row mb-2 mb-md-0 order-2 order-md-1 align-items-center"
      >
        <h5 class="font-size-16 mb-0 text-uppercase" style="font-weight: 600">
          Gerar Relatórios e Planilhas
        </h5>
      </div>

      <div class="d-flex justify-content-end flex-wrap gap-2">
        <b-button
          variant="info"
          class="mb-2 mb-md-0 d-flex align-items-center"
          @click="abrirModal(MODAIS.FOLHA_PRODUCAO)"
        >
          <i class="label-icon mdi mdi-clipboard-text-multiple font-size-15 me-1"></i>
          <span>Folha de Produção</span>
        </b-button>

        <b-button
          variant="info"
          @click="abrirModal(MODAIS.MOVIMENTACOES)"
          class="button-style mb-2 mb-md-0 d-flex justify-content-center align-items-center gap-1"
        >
          <i
            class="mdi mdi-bank-transfer icon-button d-flex align-items-center justify-content-center font-size-22 label-icon"
          ></i>
          <span>Movimentações</span>
        </b-button>

        <b-button
          variant="info"
          @click="abrirModal(MODAIS.TRANSFERENCIA)"
          class="button-style mb-2 mb-md-0 d-flex justify-content-center align-items-center gap-1"
        >
          <i
            class="mdi mdi-account-cash icon-button d-flex align-items-center justify-content-center font-size-18 label-icon"
          ></i>
          <span>Transferências</span>
        </b-button>

        <b-button
          variant="info"
          @click="abrirModal(MODAIS.PROJ_GERAL)"
          class="button-style mb-2 mb-md-0 d-flex justify-content-center align-items-center gap-1"
        >
          <i
            class="icon-button d-flex align-items-center justify-content-center font-size-18 label-icon mdi mdi-account-cowboy-hat"
          ></i>
          <span>Projetos Astec</span>
        </b-button>

        <b-button
          variant="info"
          @click="abrirModal(MODAIS.PROJ_CSV)"
          class="button-style mb-2 mb-md-0 d-flex justify-content-center align-items-center gap-1"
        >
          <i
            class="icon-button d-flex align-items-center justify-content-center font-size-18 label-icon mdi mdi-microsoft-excel"
          ></i>
          <span>Projetos Astec CSV</span>
        </b-button>
      </div>
    </b-card>

    <RelatorioFolhaProducao
      :filtros-de-projetos="filtrosDeProjetos"
      :isOpenModal.sync="modais[MODAIS.FOLHA_PRODUCAO]"
      @fechar="fecharModalAtivo(MODAIS.FOLHA_PRODUCAO)"
    />

    <RelatorioMovimentacoes
      :filtros-de-projetos="filtrosDeProjetos"
      :isOpenModal="modais[MODAIS.MOVIMENTACOES]"
      @fechar="fecharModalAtivo(MODAIS.MOVIMENTACOES)"
    />

    <RelatorioTransferencia
      :filtros-de-projetos="filtrosDeProjetos"
      :isOpenModal="modais[MODAIS.TRANSFERENCIA]"
      @fechar="fecharModalAtivo(MODAIS.TRANSFERENCIA)"
    />

    <RelatorioProjetosAstecGeral
      :isOpenModal="modais[MODAIS.PROJ_GERAL]"
      :filtros-de-projetos="filtrosDeProjetos"
      @fechar="fecharModalAtivo(MODAIS.PROJ_GERAL)"
    />

    <RelatorioProjetosAstecGeralCsv
      :isOpenModal="modais[MODAIS.PROJ_CSV]"
      :filtros-de-projetos="filtrosDeProjetos"
      @fechar="fecharModalAtivo(MODAIS.PROJ_CSV)"
    />
  </div>
</template>

<script lang="js">
import RelatorioTransferencia from './transferencia/index.vue'
import RelatorioMovimentacoes from './movimentacoes/index.vue'
import RelatorioProjetosAstecGeral from './projetos/index.vue'
import RelatorioFolhaProducao from './folhaProducao/index.vue'
import { filtrosProjetosHelper } from "@/store/helpers/vuex/astec";
import RelatorioProjetosAstecGeralCsv from './projetos/ExportarCSV.vue'

export const MODAIS = Object.freeze({
  PROJ_CSV: 'projCsv',
  PROJ_GERAL: 'projGeral',
  MOVIMENTACOES: 'movimentacoes',
  TRANSFERENCIA: 'transferencia',
  FOLHA_PRODUCAO: 'folhaProducao',
});

export default {
  components: {
    RelatorioMovimentacoes,
    RelatorioTransferencia,
    RelatorioFolhaProducao,
    RelatorioProjetosAstecGeral,
    RelatorioProjetosAstecGeralCsv,
  },

  props: {
    loadingExterno: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      MODAIS,
      modalAtivo: null,
      modais: {
        [MODAIS.PROJ_CSV]: false,
        [MODAIS.PROJ_GERAL]: false,
        [MODAIS.MOVIMENTACOES]: false,
        [MODAIS.TRANSFERENCIA]: false,
        [MODAIS.FOLHA_PRODUCAO]: false,
      },
    }
  },

  computed: {
    ...filtrosProjetosHelper({
      state: [
        "selecaoSafra",
        "selecaoCooperado",
        "selecaoTipoProjeto",
        "selecaoStatusProjeto",
        "selecaoItemAgropecuario",
        "selecaoInstituicaoFinanceira",
      ],
      getters: ["filtroProjetos", "hasFiltrosAtivos"],
    }).computed,

    filtrosDeProjetos() {
      return {
        safra: this.selecaoSafra,
        cooperado: this.selecaoCooperado,
        tipoProjeto: this.selecaoTipoProjeto,
        statusProjeto: this.selecaoStatusProjeto,
        itemAgropecuario: this.selecaoItemAgropecuario,
        instituicaoFinanceira: this.selecaoInstituicaoFinanceira,
      };
    }
  },

  methods: {
    abrirModal(modalName) {
      this.fecharTodosModais();
      this.modais[modalName] = true;
    },

    fecharModalAtivo(modalName) {
      this.modais[modalName] = false;
    },

    fecharTodosModais() {
      Object.keys(this.modais).forEach(modalName => {
        this.modais[modalName] = false
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.button-style {
  min-width: 150px;
}

.icon-button {
  height: 20px;
  width: 20px;
}
</style>
